import React, { useState, useEffect, useRef } from 'react';
import './App.css';

function App() {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const handleCTA = () => {
    // Отправка события Purchase в Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Практикум КЛЮЧ',
        value: 89.00,
        currency: 'USD'
      });
    }
    
    // Переход на страницу оплаты в новой вкладке
    window.open('https://secure.wayforpay.com/payment/wishcametrue2', '_blank');
  };

  const handleTelegramClick = () => {
    // Отправка события Lead в Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Telegram Support Contact'
      });
    }
  };

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observe all sections
    const sections = document.querySelectorAll('.animate-on-scroll');
    sections.forEach(section => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  const faqData = [
    {
      question: 'Как я попаду в закрытый Telegram-канал после оплаты?',
      answer: 'После оплаты на ваш e-mail автоматически придёт письмо с приглашением в закрытый канал практикума. Кроме того, сразу после успешной оплаты откроется страница с кнопкой «Перейти в канал» — вы сможете присоединиться в один клик.'
    },
    {
      question: 'Нужен ли опыт медитаций или телесных практик?',
      answer: 'Нет. Всё объясняется пошагово. Достаточно желания и готовности уделять время себе.'
    },
    {
      question: 'Сколько времени нужно в день?',
      answer: 'В среднем 15–30 минут на практики и задания, вы можете проходить их в удобное время.'
    },
    {
      question: 'Если пропущу день, не отстану ли я?',
      answer: 'Нет. Все материалы остаются в канале, вы можете проходить в своём ритме.'
    },
    {
      question: 'Можно ли участвовать из другой страны/часового пояса?',
      answer: 'Да, практикум полностью онлайн, доступ открыт 24/7.'
    },
    {
      question: 'Что делать, если не приходит письмо с приглашением?',
      answer: 'Проверьте папку «Спам» или «Промо». Если письма нет — напишите нам на указанную внизу лендинга почту поддержки, и мы вышлем ссылку вручную.'
    }
  ];

  const features = [
    'Вы замечаете, что ваши желания и планы не воплощаются в жизнь, даже когда вы стараетесь.',
    'Чувствуете, что потерялись или находитесь на перепутье, не понимаете, какой следующий шаг сделать.',
    'Живёте как в «дне сурка» и хотите увидеть, как выйти из этого замкнутого круга и начать делать шаги к изменениям.',
    'Усталость и внутренний шум мешают услышать своё настоящее «Я».',
    'Чувствуете, что потеряли связь с собой и своим телом, внутри — пустота и непонятно, где взять силы.',
    'Ищете структурированный, практический процесс, который объединяет работу с телом, сознанием и энергией и помогает мягко выйти на новый уровень жизни.'
  ];

  const benefits = [
    'Навык формировать ясные, сильные намерения, которые действительно воплощаются в жизнь.',
    'Глубокий контакт с телом — вы начнёте чувствовать его как источник энергии и внутренней опоры.',
    'Освобождение от накопленного напряжения и блоков, чтобы энергия текла свободно.',
    'Умение управлять своим состоянием: быстро возвращать себе спокойствие, фокус и ресурс.',
    'Повышенную чувствительность к истинным желаниям и понимание того, чего вы хотите на самом деле.',
    'Первые реальные перемены уже в процессе месяца: лёгкость, ясность, новые возможности.'
  ];

  return (
    <div className="app">
      {/* Start Date Badge */}
      <div className="start-date-badge" data-testid="start-date-badge">
        <div className="badge-icon">🗝️</div>
        <div className="badge-text">
          <span className="badge-label">СТАРТ:</span>
          <span className="badge-date">1 февраля 2026</span>
        </div>
      </div>

      {/* Hero Section */}
      <section className="hero" data-testid="hero-section">
        <div className="hero-background">
          <img 
            src="https://customer-assets.emergentagent.com/job_russian-chat-61/artifacts/q2to6za5_IMG_9430.PNG" 
            alt="Золотой ключ" 
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <div className="hero-key-icon">🗝️</div>
          <h1 className="hero-title" data-testid="hero-title">
            ТВОЯ РЕАЛЬНОСТЬ<br />НАЧИНАЕТСЯ ВНУТРИ
          </h1>
          <p className="hero-subtitle">
            В каждом из нас есть свой <strong className="highlight-gold">ключ</strong>, который открывает двери к переменам и новым возможностям.<br />
            Этот практикум поможет Вам соединить <strong className="highlight-gold">тело, разум и душу</strong>, чтобы желаемое стало реальностью.
          </p>
          <button className="cta-button hero-cta" onClick={handleCTA} data-testid="hero-cta-button">
            Начать создавать свою реальность
          </button>
        </div>
      </section>

      {/* About Section */}
      <section className="about animate-on-scroll" data-testid="about-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-image slide-in-left">
              <img 
                src="https://customer-assets.emergentagent.com/job_russian-chat-61/artifacts/i1xy42qr_IMG_9429.PNG" 
                alt="Медитация с ключом"
              />
            </div>
            <div className="about-content slide-in-right">
              <h2 className="section-title" data-testid="about-title">О практикуме</h2>
              <div className="divider"></div>
              <p className="about-text">
                <strong className="highlight-gold">«Ключ»</strong> — авторская система работы с <strong>телом, энергией и намерением</strong>.
              </p>
              <p className="about-text">
                Когда <strong className="highlight-text">внутренний компас настроен</strong>, а тело свободно от блоков, ваши желания и идеи перестают быть фантазией и <strong className="highlight-gold">становятся реальностью</strong>.
              </p>
              <p className="about-text">
                Это чёткий практический метод: <strong>пошаговое погружение</strong>, которое возвращает вас к опоре, ясности и открывает ваши собственные двери.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* For Whom Section */}
      <section className="for-whom animate-on-scroll" data-testid="for-whom-section">
        <div className="container">
          <h2 className="section-title" data-testid="for-whom-title">Для кого практикум</h2>
          <div className="divider"></div>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div className="feature-card slide-in-up" key={index} data-testid={`feature-card-${index}`} style={{animationDelay: `${index * 0.1}s`}}>
                <p>{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Structure Section */}
      <section className="structure animate-on-scroll" data-testid="structure-section">
        <div className="container">
          <h2 className="section-title" data-testid="structure-title">Структура практикума</h2>
          <div className="divider"></div>
          <h3 className="structure-subtitle slide-in-up"><strong className="highlight-gold">7 последовательных шагов</strong></h3>
          <p className="structure-intro slide-in-up">
            Практикум проходит в <strong className="highlight-gold">закрытом Telegram-канале</strong> и выстроен как путь из семи чётких этапов. 
            Каждый шаг — это отдельные уроки и практики, которые логично продолжают друг друга, 
            ведя вас к <strong className="highlight-text">внутренней опоре</strong> и к активации вашего личного <strong className="highlight-gold">«ключа» перемен</strong>.
          </p>
          
          <div className="structure-content slide-in-up">
            <div className="structure-box">
              <h4>В каждом шаге:</h4>
              <ul>
                <li>
                  <span className="bullet">🔸</span>
                  <div className="list-content">
                    <strong>Телесные техники</strong> — мягкое снятие блоков и настройка проводимости энергии.
                  </div>
                </li>
                <li>
                  <span className="bullet">🔸</span>
                  <div className="list-content">
                    <strong>Медитации и визуализации</strong> — для глубинного контакта с собой.
                  </div>
                </li>
                <li>
                  <span className="bullet">🔸</span>
                  <div className="list-content">
                    <strong>Практические задания</strong> — на работу с Вашим желанием.
                  </div>
                </li>
                <li>
                  <span className="bullet">🔸</span>
                  <div className="list-content">
                    <strong>Поддержка и обратная связь</strong> — авторы отвечают на вопросы и помогают двигаться дальше.
                  </div>
                </li>
              </ul>
            </div>
            
            <div className="structure-details">
              <p>
                За месяц вы проходите <strong className="highlight-gold">полный цикл</strong> — от первого соприкосновения с телом до ясного, 
                сильного намерения, которое открывает двери к желаемой реальности.
              </p>
              <div className="structure-info">
                <div className="info-item">
                  <strong className="highlight-gold">Длительность практикума:</strong> 1&nbsp;месяц
                </div>
                <div className="info-item">
                  <strong className="highlight-gold">Доступ после окончания:</strong> 2&nbsp;месяца
                </div>
              </div>
            </div>
          </div>
          
          <div className="cta-center">
            <button className="cta-button" onClick={handleCTA} data-testid="structure-cta-button">
              Получить ключ
            </button>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits animate-on-scroll" data-testid="benefits-section">
        <div className="container">
          <div className="benefits-grid">
            <div className="benefits-image slide-in-left">
              <img 
                src="https://customer-assets.emergentagent.com/job_russian-chat-61/artifacts/trgwttz3_IMG_9426.PNG" 
                alt="Ключ в космосе"
              />
            </div>
            <div className="benefits-content slide-in-right">
              <h2 className="section-title" data-testid="benefits-title">Что вы получите на практикуме</h2>
              <div className="divider"></div>
              <ul className="benefits-list">
                {benefits.map((benefit, index) => (
                  <li key={index} data-testid={`benefit-item-${index}`}>
                    <span className="benefit-icon">🔑</span>
                    <span dangerouslySetInnerHTML={{__html: benefit.replace(/ясные, сильные намерения/g, '<strong class="highlight-gold">ясные, сильные намерения</strong>').replace(/источник энергии/g, '<strong class="highlight-text">источник энергии</strong>').replace(/энергия текла свободно/g, '<strong class="highlight-gold">энергия текла свободно</strong>').replace(/спокойствие, фокус и ресурс/g, '<strong class="highlight-text">спокойствие, фокус и ресурс</strong>').replace(/истинным желаниям/g, '<strong class="highlight-gold">истинным желаниям</strong>').replace(/лёгкость, ясность, новые возможности/g, '<strong class="highlight-gold">лёгкость, ясность, новые возможности</strong>')}}></span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Authors Section */}
      <section className="authors animate-on-scroll" data-testid="authors-section">
        <div className="container">
          <h2 className="section-title" data-testid="authors-title">Авторы</h2>
          <div className="divider"></div>
          
          <div className="authors-grid">
            <div className="author-card slide-in-up" data-testid="author-apollinaria" style={{animationDelay: '0.1s'}}>
              <div className="author-image">
                <img 
                  src="https://customer-assets.emergentagent.com/job_russian-chat-61/artifacts/vmtn5c32_6W5A9362.jpg" 
                  alt="Аполлинария Шутова"
                />
              </div>
              <h3 className="author-name">Аполлинария Шутова</h3>
              <p className="author-description">
                <strong className="highlight-text">Клинический и кризисный психолог</strong>. Создатель методик, соединяющих работу с телом, 
                энергией и сознанием. Ведёт людей к внутренней опоре и умению <strong className="highlight-gold">материализовывать 
                желания</strong> через ясное намерение и телесную проводимость.
              </p>
            </div>
            
            <div className="author-card slide-in-up" data-testid="author-tatiana" style={{animationDelay: '0.2s'}}>
              <div className="author-image">
                <img 
                  src="https://customer-assets.emergentagent.com/job_russian-chat-61/artifacts/ohd5ytzn_IMG_9435.JPG" 
                  alt="Татьяна Фёдоровна"
                />
              </div>
              <h3 className="author-name">Татьяна Фёдоровна</h3>
              <p className="author-description">
                <strong className="highlight-text">Эзотерик, энергопрактик и целитель</strong>. Работает с тонкими вибрациями и тантрическими 
                практиками, пробуждая <strong className="highlight-gold">скрытые ресурсы души</strong> и мягко направляя к внутренней гармонии, 
                целостности и трансформации.
              </p>
            </div>
          </div>
          
          <div className="authors-conclusion slide-in-up">
            <h3><strong className="highlight-gold">Две силы — один Ключ</strong></h3>
            <p>
              На практикуме «Ключ» соединяются <strong>психология, работа с телом и энергетические практики</strong>. 
              Психологический и телесный подход Аполлинарии сочетается с тонкой работой Татьяны с 
              энергией и пространством, формируя <strong className="highlight-gold">единый маршрут к Вашим изменениям</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq animate-on-scroll" data-testid="faq-section">
        <div className="container">
          <h2 className="section-title" data-testid="faq-title">Часто задаваемые вопросы</h2>
          <div className="divider"></div>
          <div className="faq-list">
            {faqData.map((item, index) => (
              <div 
                className={`faq-item slide-in-up ${openFaq === index ? 'active' : ''}`} 
                key={index}
                data-testid={`faq-item-${index}`}
                style={{animationDelay: `${index * 0.05}s`}}
              >
                <div 
                  className="faq-question" 
                  onClick={() => toggleFaq(index)}
                  data-testid={`faq-question-${index}`}
                >
                  <h4>{item.question}</h4>
                  <span className="faq-icon">{openFaq === index ? '−' : '+'}</span>
                </div>
                {openFaq === index && (
                  <div className="faq-answer" data-testid={`faq-answer-${index}`}>
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="final-cta animate-on-scroll" data-testid="final-cta-section">
        <div className="container">
          <div className="final-cta-content slide-in-up">
            <h2>Готовы открыть свою дверь к переменам?</h2>
            <p>Начните свой <strong className="highlight-gold">путь трансформации</strong> уже сегодня</p>
            <button className="cta-button" onClick={handleCTA} data-testid="final-cta-button">
              Присоединиться к практикуму
            </button>
            <div className="pricing" data-testid="pricing">
              <span className="price-current">89$</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer" data-testid="footer">
        <div className="container">
          <p>© 2025 Практикум <strong className="highlight-gold">«КЛЮЧ»</strong>. Все права защищены.</p>
          <div className="telegram-support">
            <p>Не пришло письмо с доступом к каналу?</p>
            <a href="https://t.me/ApollinarisSh" target="_blank" rel="noopener noreferrer" className="telegram-button" data-testid="telegram-support-link" onClick={handleTelegramClick}>
              <svg className="telegram-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z"/>
              </svg>
              Написать в Telegram
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;